import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../../../../Material-Module';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MainNavbarComponent } from '../../../../core/components/main-navbar/main-navbar.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CustomSearchComponent } from '../custom-search/custom-search.component';
import { ThemeCatalogueComponent } from '../theme-catalogue/theme-catalogue.component';
import { Store } from '@ngrx/store';
import { submitSearch } from 'src/app/state/action';



@Component({
  selector: 'app-thematic-home',
  standalone: true,
  imports: [MaterialModule, CommonModule, MainNavbarComponent, FormsModule, ReactiveFormsModule, CustomSearchComponent, ThemeCatalogueComponent],
  templateUrl: './thematic-home.component.html',
  styleUrl: './thematic-home.component.css'
})
export class ThematicHomeComponent implements OnInit {
  user_input = new FormControl<string>('');
  isLoading = false;
  theme: string = '';
  thematic_search_type: string = 'theme_definer';
  recentSearches: string[] = [];
  transitioning: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private store: Store
  ) { }

  ngOnInit() {
    this.loadRecentSearches();
  }
  hasSearched: boolean = false;
  defineTheme() {
    this.hasSearched = false;
    this.transitioning = false;
    const input = this.user_input.value?.trim();
    if (!input) {
      return;
    }

    this.addRecentSearch(input);
    this.isLoading = true;

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem('current_user_token')
    });

    this.http.post<any>(
      '/backend/themeAssistant/theme/define',
      { user_message: input },
      { headers }
    ).subscribe({
      next: res => {
        this.theme = res.payload.query;
        this.isLoading = false;
        this.hasSearched = true;

        // Check if the theme contains at least one letter
        const containsLetter = /[a-zA-Z]/.test(this.theme);

        // Proceed only if there is at least one letter in the theme
        if (containsLetter) {
          setTimeout(() => {
            this.transitioning = true;
            setTimeout(() => {
              const searchParams = { 'themes': [{ 'api_query': this.theme, 'name': res.payload.name }] };
              this.store.dispatch(submitSearch({ searchParams, searchType: 'theme' }));
            }, 3000);
          }, 2000);
        }
      },
      error: () => {
        this.hasSearched = true;
        this.isLoading = false;
        this.transitioning = false;

      }
    });
  }



  addRecentSearch(term: string) {
    let searches = JSON.parse(localStorage.getItem('recent_searches') || '[]');
    searches = [term, ...searches.filter((s: string) => s !== term)].slice(0, 5);
    localStorage.setItem('recent_searches', JSON.stringify(searches));
    this.recentSearches = searches;
  }

  loadRecentSearches() {
    this.recentSearches = JSON.parse(localStorage.getItem('recent_searches') || '[]');
  }

  removeRecent(term: string) {
    const updated = this.recentSearches.filter(s => s !== term);
    localStorage.setItem('recent_searches', JSON.stringify(updated));
    this.recentSearches = updated;
  }
  showRecent = true;

  toggleRecent() {
    this.showRecent = !this.showRecent;
  }


  setSearch(term: string) {
    this.user_input.setValue(term);
  }

  selectThemeSearchType(type: string) {
    this.thematic_search_type = type;
  }

  get isThemeEmpty(): boolean {
    return this.hasSearched && this.theme?.replace(/"/g, '').trim() === '';
  }
  pastelColors: string[] = [
    '#EBDCF9', 
    '#D0EBF9', 
    '#D5F5E3', 
    '#FFF3CD',
    '#FADBD8',
    '#E8DAEF'  
  ];
  icons: string[] = ['🕒'];

  trendingThemes =  [
    { name: 'AI-based medical devices for diagnosis or medical image analysis' },
    { name: 'Heat exchange equipment for industrial cooling or energy systems'},
    { name: 'Computer systems (excluding consumer software)' },
    { name: 'Geophysics for subsurface exploration (not weather modeling)' },
    { name: 'Healthcare data and hospital information systems' }
  ]; 
  
  selectTrendingTheme(item: { name: string;}) {
  // const query = `tf="${item.name}"`;
  //   const searchParams = { themes: [{ api_query:  query, name: item.name }] };
  //   this.store.dispatch(submitSearch({ searchParams, searchType: 'theme' }));  
  this.user_input.setValue(item.name);
  this.defineTheme();
  }

  openIdeaGeneration(){
    this.router.navigate(['/idea-generation']);
  }
}
